import { render, staticRenderFns } from "./send-message.vue?vue&type=template&id=3839d1df&scoped=true&"
import script from "./send-message.vue?vue&type=script&lang=js&"
export * from "./send-message.vue?vue&type=script&lang=js&"
import style0 from "./send-message.vue?vue&type=style&index=0&id=3839d1df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3839d1df",
  null
  
)

export default component.exports